//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { ExampleDatasetInstallation } from "../../api/lib";

export const useExampleDatasetInstallationStatus = ({ installation }: { installation: ExampleDatasetInstallation | undefined }) => {
  const { status: installationStatus = {}, is_deleted: isUninstalling } = installation || {};
  const { is_available: isAvailable, is_failed: isFailed, database_name: databaseName, demo_url: demoUrl, state } = installationStatus;

  // data-manager marks status.state=Deleted on DB drift without soft-delete (is_deleted).
  // Treat that terminal Deleted state as "no installation" so the UI shows Install instead of "Creating DB".
  // While uninstall is in progress (is_deleted), keep hasInstallation so the Uninstalling spinner still shows.
  const isTerminalDeleted = state === "Deleted" && !isUninstalling;
  const hasInstallation = !!installation && !isTerminalDeleted;
  const hasDemo = !!isAvailable && !isUninstalling && !!demoUrl;
  const isCreatingDatabase = hasInstallation && !isAvailable && !isFailed;
  const isInstalling = hasInstallation && !isAvailable && !isFailed && !!databaseName;
  const isBusy = isCreatingDatabase || isInstalling || isUninstalling;

  const getLoadingText = () => {
    if (isInstalling) {
      return "Installing";
    }
    if (isCreatingDatabase) {
      return "Creating DB";
    }
    return "Getting ready";
  };

  const loadingText = getLoadingText();

  return { hasInstallation, databaseName, loadingText, isUninstalling, isBusy, hasDemo, demoUrl };
};
